module.exports = __webpack_public_path__ + "static/wedding_3-919ad5df8226439e3872fe8281752546.jpg";